/* eslint-disable @typescript-eslint/no-explicit-any */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { TextField } from "@material-ui/core";
import { FC, Fragment, Ref, useState } from "react";
import { useIntl } from "react-intl";
import tinyColor from "tinycolor2";
import { useBooleanState } from "../../../../hooks/utils";
import ColorPickerModal from "../../../molecules/modals/ColorPickerModal";
import { textFieldCss, textFieldInputCss } from "../commonStyles";

type ControlledOnlyProps = { value: string; defaultValue?: undefined };
type UncontrolledOnlyProps = { value?: undefined; defaultValue: string };

type Props = (ControlledOnlyProps | UncontrolledOnlyProps) & {
  label?: string;
  value?: string;
  defaultValue?: string;
  inputRef?: Ref<any>;
  onChange?: (value: string) => void;
  onBlur?(): void;
  className?: string;
  name?: string;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
};

const InputComponent = (props: any) => (
  <input
    {...props}
    css={textFieldInputCss}
    ref={props.inputRef}
    enterKeyHint="done"
  />
);

const FlowioColorInput: FC<Props> = ({
  label,
  value,
  defaultValue,
  inputRef,
  onChange,
  onBlur,
  className,
  name,
  placeholder,
  disabled,
  required = false,
}) => {
  const [isOpen, toggleModal] = useBooleanState(false);
  const [selectedColor, setColor] = useState(defaultValue || value);
  const { formatMessage } = useIntl();

  const selectColor = (newColor: string) => {
    if (onChange) {
      onChange(newColor);
    }

    setTimeout(() => onBlur?.(), 0);

    setColor(newColor);
    toggleModal();
  };

  const buttonStyle = {
    background: selectedColor || "",
    color: tinyColor(selectedColor).isLight() ? "black" : "white",
  };

  const onClickInput = () => {
    if (!disabled) {
      toggleModal();
    }
  };

  return (
    <Fragment>
      <TextField
        css={textFieldCss()}
        style={{ ...buttonStyle }}
        type="search"
        label={label}
        value={value || selectedColor}
        onClick={onClickInput}
        placeholder={
          placeholder || formatMessage({ id: "personalization.chose_color" })
        }
        InputProps={{
          defaultValue,
          disableUnderline: true,
          inputComponent: InputComponent,
          inputRef,
          name,
          inputProps: { "data-cy": "input flowio-color-input" },
        }}
        className={className}
        disabled={disabled}
        required={required}
      />
      <ColorPickerModal
        isOpen={isOpen}
        toggleModal={toggleModal}
        color={selectedColor || ""}
        callbackFnc={selectColor}
      />
    </Fragment>
  );
};

export default FlowioColorInput;
export type FlowioColorInputProps = Props;
